import React, { useEffect } from "react";

import FormDetails from "./form-details";
import FormInputs from "./form-inputs";
import FormInput from "./form-input";
import { Grid } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import "../../../../../styles/css/App.css";
import Style from "../../../../../styles/js/StyleCallList.js";
import * as Constants from "../../../../../consts/Constants.js";
import CircularProgress from '@mui/material/CircularProgress';
import service from "../../../../../plas/services/calls/service";

function Form({ history, formId }) {
  
  const style = Style();
  const [loading, setLoading] = React.useState(true);
  const [inputsDisabled, setInputsDisabled] = React.useState(false);
  const [form, setForm] = React.useState(null);
  const [selectedInputId, setSelectedInputId] = React.useState(null);

  useEffect(() => {
    getForm();
  }, []);

  const getForm = () => {
    service.api.configurations.get(formId, (response) => {
      if (response.result != null) {
        let data = response.result
        setForm(data);
      }
      setLoading(false);
    });
  }

  const selectInput = (inputId) => {
    setSelectedInputId(inputId);
  }

  const getInput = (inputId) => {
    for (var index = 0; index < form.inputs.length; index++) {
      if (form.inputs[index].id === inputId) {
        return form.inputs[index];
      }
    }
    return null;
  }

  const disableInputEdition = (disable) => {
    setInputsDisabled(disable);
  }

  return (
    <div className={style.box} >
      { loading ?
        (
          <div style={{color:Constants.COLOR_PRIMARY}}>
            <CircularProgress color="inherit" />
          </div>
        ) : (
          <div className={style.box}>
            <Grid container spacing={2} style={{height:"100%"}}>
              <Grid item md={5} xs={12}>
                <FormDetails form={form} />
                <FormInputs form={form} select={selectInput} disable={disableInputEdition} disabled={inputsDisabled}/>
              </Grid>
              <Grid item md={7} xs={12}>
                <FormInput form={form} input={getInput(selectedInputId)} disable={disableInputEdition} disabled={inputsDisabled} />
              </Grid>
            </Grid>
          </div>
        )
      }

    </div>
  );
}

export default withRouter(Form);